import type { MenuListProps, MenuProps, PopoverProps } from '@mui/material';
import { Menu, styled } from '@mui/material';
import type React from 'react';

type ContextMenuAnchorEl = MenuProps['anchorEl'];

type StyledContextMenuProps = {
  open: boolean;
  anchorEl: ContextMenuAnchorEl;
  onClose: (event: React.MouseEvent<HTMLElement>) => void;
  MenuListProps?: Partial<MenuListProps> | undefined;
  children?: React.ReactNode;
  anchorOrigin?: PopoverProps['anchorOrigin'];
  transformOrigin?: PopoverProps['transformOrigin'];
} & React.HTMLAttributes<HTMLUListElement>;

export const StyledContextMenu = ({
  open,
  anchorEl,
  onClose,
  MenuListProps,
  children,
  anchorOrigin = { vertical: 'top', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
}: StyledContextMenuProps) => (
  <StyledMenu
    role="menu"
    aria-label="Options"
    anchorEl={anchorEl}
    onClose={onClose}
    open={open}
    MenuListProps={MenuListProps}
    anchorOrigin={anchorOrigin}
    transformOrigin={transformOrigin}
  >
    {children}
  </StyledMenu>
);

const StyledMenu = styled(Menu)<{ open: boolean }>(({ open }) => ({
  paddingTop: '0px',
  paddingBottom: '0px',
  overflowY: 'hidden',
  zIndex: 20,
  '& .MuiMenu-paper': {
    transition: 'opacity 0.3s ease',
    opacity: open ? '1' : '0',
  },
  '& .MuiMenu-list': {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));
